export async function getAvailableStorageSpace() {
  if ("storage" in navigator && "estimate" in navigator.storage) {
    const { quota, usage } = await navigator.storage.estimate();
    if (!quota || !usage) {
      throw new Error("error calculating storage");
    }
    const availableSpace = quota - usage;
    return availableSpace;
  } else {
    console.warn("Storage API is not supported by this browser.");
    return 10000000000;
  }
}
